import React from "react";

import {Three, Verify, Cup, Transparency} from "components/icons";
import {useTranslation} from "react-i18next";

import "./Description.css";

const Description = () => {
    const {t} = useTranslation();

    return (
        <div className="home-description">
           <div className="container">
               <div className="home-description__container">
                   <div className="home-description__left">
                       <Three/>
                       <p>{t("THREE_REASONS_TO_JOIN_1X2")}</p>
                   </div>
                   <div className="home-description__right">
                       <div className="home-description__item">
                           <div className="home-description__icon-box">
                               <Cup/>
                           </div>
                           <span className="home-description__text">{t("BIG_WINNING_FUND")}</span>
                       </div>
                       <div className="home-description__item">
                           <div className="home-description__icon-box">
                               <Verify/>
                           </div>
                           <span className="home-description__text">{t("RELIABILITY")}</span>
                       </div>
                       <div className="home-description__item">
                           <div className="home-description__icon-box">
                               <Transparency/>
                           </div>
                           <span className="home-description__text">{t("TRANSPARENCY")}</span>
                       </div>
                   </div>
               </div>
           </div>
        </div>
    )
}

export default Description